import React from "react";
import MaterialTable from "material-table";
import tableicons from "../tableicons";

class TablaAjustes extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            selectedRow:null,
        }
    }

    render() {
        return (
            <MaterialTable
                localization={{
                    toolbar: {
                        searchPlaceholder: 'Buscar'
                    },
                    header: {
                        actions: 'Acciones'
                    },
                    body:{
                        emptyDataSourceMessage: 'No hay datos para mostrar'
                    }
                }}
                options={{
                    pageSize: 10,
                    pageSizeOptions: [10, 25, 50, 100],
                    actionsColumnIndex: -1,
                    rowStyle: rowData => ({
                        backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                    }),
                    searchFieldStyle: {
                        width: "auto",
                    },
                    padding: "dense"
                }}
                icons={tableicons}
                title="Modificaciones realizadas"
                data={this.props.datos}
                columns={[
                    { title: 'Cantidad Inicial', field: 'cantidad_inicial'},
                    { title: 'Ajuste', field: 'ajuste'},
                    { title: 'Cantidad Final', field: 'cantidad_final'},
                    { title: 'Motivo', field: 'ajuste_motivo' },
                    { title: 'Usuario',
                        render:rowData => rowData.nombre1 + " " +rowData.apellido1,
                        customFilterAndSearch: ((term, rowData) => (rowData.nombre1 + " " +rowData.apellido1).indexOf(term) !== -1)},
                    { title: 'Fecha y hora', field: 'timestamp',
                        render: rowData => new Date(Date.parse(new Date(rowData.timestamp) + ' UTC')).toLocaleString(),
                        customFilterAndSearch: ((term,rowData) => new Date(Date.parse(new Date(rowData.timestamp) + ' UTC')).toLocaleString().indexOf(term) !== -1)},
                ]}
                onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
            />
        )
    }

}
export default TablaAjustes;